import tw from "#src/utils/tw.ts";

const CardElementContainer = (props) => (
  <div
    {...props}
    className={tw(
      "mb-6 h-[44px] rounded-[6px] border border-borderGray bg-bgGray px-4 pt-[0.8rem]",
      props.className
    )}
  />
);

export default CardElementContainer;
